import React from 'react';
import './LeftOneRightTwo.less';

interface LeftOneRightTwoState {

}

interface LeftOneRightTwoPropType {
    prefixCls?: string;
    floorId: any;
    floorTemplate: any[];
    onFloorClick: Function;
}

class LeftOneRightTwo extends React.Component<LeftOneRightTwoPropType, LeftOneRightTwoState> {
    static defaultProps = {
        prefixCls: 'leftOneRightTwo',
    };

    render() {
        const {prefixCls, floorId, floorTemplate, onFloorClick} = this.props;
        return (
            <div className={prefixCls}>
                <div className={`${prefixCls}imgBox`}>
                    <div className={`${prefixCls}leftBox`} onClick={() => {
                        onFloorClick && onFloorClick(floorId, floorTemplate[0].moduleName, floorTemplate[0].moduleUrlType, floorTemplate[0].moduleUrl);
                    }}>
                        <img src={floorTemplate[0].moduleImgUrl} alt=""/>
                    </div>
                    <div className={`${prefixCls}rightBox`}>
                        <div className={`${prefixCls}rightTopBox`} onClick={() => {
                            onFloorClick && onFloorClick(floorId, floorTemplate[1].moduleName, floorTemplate[1].moduleUrlType, floorTemplate[1].moduleUrl);
                        }}>
                            <img src={floorTemplate[1].moduleImgUrl} alt=""/>
                        </div>
                        <div className={`${prefixCls}rightBottomBox`} onClick={() => {
                            onFloorClick && onFloorClick(floorId, floorTemplate[2].moduleName, floorTemplate[2].moduleUrlType, floorTemplate[2].moduleUrl);
                        }}>
                            <img src={floorTemplate[2].moduleImgUrl} alt=""/>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default LeftOneRightTwo;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/floorModule/leftOneRightTwo/LeftOneRightTwo.tsx